import  { useEffect, useState } from 'react'
import {MwButton} from '../../components/ui'
import {langObjType,objLangTextHandler} from '../../utils/global'
import {AiOutlineSave} from 'react-icons/ai'
import BaiscInfo from './forms/BaiscInfo'
import StockAndPrice from './forms/StockAndPrice'
import SEO from './forms/SEO'
import ProductLinks from './forms/ProductLinks'
import { useCurrent, usePost,useUploadFile } from '../../hooks'
import CardHeadeWithActions from '../ui/CardHeadeWithActions'
import ProductImages from './forms/ProductImages'
import {allowImgTypes} from '../../pages/products/constants'
import { useTranslation } from 'react-i18next'
import {
    getProductTabClassName,
    PRODUCT_EDITOR_TABS,
    PRODUCT_FORM_PANEL_CLASS,
    PRODUCT_TAB_WRAPPER_CLASS,
} from './productUi'

const CreateProduct = ({onHide,onProductCreated,setReloadProductList,setMode}) => {
    const [t] = useTranslation('global')

    const [tabActive,setTabActive] = useState('TabOne');
    const [errors,setErrors] = useState({});
    const {currentTenantId,currentCompanyId,currentLangId} = useCurrent();
    const {data:resultPost,postData} = usePost();

    const [productCode,setProductCode] = useState('');
    const [,setProductImagesDefault] = useState();
    const [productBarcode,setProductBarcode] = useState('');
    const [productFactoryCode,setProductFactoryCode] = useState('');
    const [productName,setProductName] = useState(langObjType());
    const [productDesc,setProductDesc] = useState(langObjType());
    const [productPrice,setProductPrice] = useState('');
    const [productTypeSelected,setProductTypeSelected] = useState();
    const [isActive,setIsActive] = useState(true);
    const [isShowOnWebsite,setIsShowOnWebsite] = useState(false);
    const [qty,setQty] = useState(0);
    const [cost,setCost] = useState();
    const [productMetaKeywords,setProductMetaKeywords] = useState(langObjType());
    const [productMetaDesc,setProductMetaDesc] = useState(langObjType());
    const [isStock,setIsStock] = useState(false);
    const [codeInStock,setCodeInStock] = useState();
    const [weightProduct,setWeightProduct] = useState();
    const [sizeProduct,setSizeProduct] = useState();
    const [uomTemplateSelected,setTemplateUomSelected] = useState();
    const [uomSaleSelected,setUomSaleSelected] = useState();
    const [uomPurchaseSelected,setUomPurchesSelected] = useState();

    const [genProductCode,setGenProductCode] = useState();
    const [productCategorySelected,setProductCategorySelected] = useState([]);
    const [productBrandSelected,setProductBrandSelected] = useState();
    const [productTags,setProductTags] = useState([]);

    const [productImages,setProductImages] = useState([]);
    const {location:productHomePic,loading:loadingUploadHomePic,handleUpload:handleHomePicUpload} = useUploadFile(allowImgTypes,`products-${currentTenantId}`,'image')
    const {location:productImagesItem,loading:loadingUploadProductImages,handleMultiUploads:handleImagesItemUpload} = useUploadFile(allowImgTypes,`products-${currentTenantId}`,'image')
    const {resultdelete,loadingDeleting,handleDelete} = useUploadFile()

    useEffect(()=>{
        if(productImagesItem){
            setProductImages((state) => [...state,productImagesItem]);
        }
    },[productImagesItem])

    const cancelHandle = () => {
        onHide && onHide();
    }

    const saveHandler = async (e) => {
        e.preventDefault(true);
        let errorObj = {};
        if(!productName[currentLangId]){
            errorObj = { ...errorObj, [`productName.${currentLangId}`] : t('validation.productNameRequired')};
        }
        if(!productTypeSelected){
            errorObj = {...errorObj, productType:t('validation.productTypeRequired')}
            productName[currentLangId] && setTabActive('TabOne');
        }
        if(!productPrice){
            errorObj = {...errorObj, price:t('validation.productPriceRequired')}
            productName[currentLangId] && setTabActive('TabTwo');
        }else if(isNaN(parseFloat(productPrice))){
            errorObj = {...errorObj, price:t('validation.productPriceInvalid')}
            productName[currentLangId] && setTabActive('TabTwo');
        }
        
        if(Object.keys(errorObj).length !== 0 ){
            setErrors(errorObj)
            return
        }

        onHide && setReloadProductList && setReloadProductList(false)
        const _data = {
            productName : objLangTextHandler(productName) ,
            productDesc :objLangTextHandler(productDesc),
            productMetaKeywords :objLangTextHandler(productMetaKeywords),
            productMetaDesc :objLangTextHandler(productMetaDesc),
            productTags: JSON.stringify(productTags),
            productCategory: productCategorySelected?.map((item) => item['value'] ),
            productBrand:productBrandSelected?.value || null,
            productType: productTypeSelected?.value ,
            productHomePic: productHomePic || null,
            productImages: productImages,
            productCode,
            productBarcode,
            productFactoryCode,
            codeInStock,
            weightProduct,
            sizeProduct,
            price:productPrice,
            qty:qty,
            cost: cost,
            uomTemplate:{
                id : uomTemplateSelected?.data.id,
                name : uomTemplateSelected?.data.name,
            },
            uomSale:{
                id: uomSaleSelected?.data.id,
                name: uomSaleSelected?.data.name,
                short_name: uomSaleSelected?.data.short_name,
                rate: uomSaleSelected?.data.rate,
            },
            uomPurchase:{
                id: uomPurchaseSelected?.data.id,
                name: uomPurchaseSelected?.data.name,
                short_name: uomPurchaseSelected?.data.short_name,
                rate: uomPurchaseSelected?.data.rate,
            },
            isStock,
            isShowOnWebsite,
            isActive,
            tenantId:currentTenantId,
            companyId : currentCompanyId
        };
        postData(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}`, _data);
    }

    useEffect(()=>{
        if(resultPost){
            if(resultPost.status === 1){
                localStorage.setItem('isProductsUpdated','true')
                onHide && onHide();
                onHide ? onProductCreated() : setMode('List') ;
            }else if(resultPost.status === 0){
                setErrors((state) => ({ ...state, [`productName.${currentLangId}`] : resultPost.message }));
                productName[currentLangId] && setTabActive('TabOne');
            }
        }
    },[resultPost,currentLangId,onHide,onProductCreated,productName,setMode]);

    return (
        <div className='p-5'>
            <CardHeadeWithActions title={t('product.addNewProduct')}>
                {onHide && <MwButton inGroup={true} type='cancelBtn' onClick={cancelHandle}>{t('common.cancel')}</MwButton>}
                <MwButton type="saveBtn" inGroup={true} onClick={() => setMode('List')}>{t('product.manageProducts')}</MwButton>
                <MwButton inGroup={true} type='saveBtn' onClick={saveHandler}>{t('product.save')} <AiOutlineSave size={18}/></MwButton>
            </CardHeadeWithActions>

            <form className='mt-3'>
                <div className={PRODUCT_FORM_PANEL_CLASS}>
                    <ul className={PRODUCT_TAB_WRAPPER_CLASS}>
                        {PRODUCT_EDITOR_TABS.map((tab) => (
                            <li
                                key={tab.key}
                                onClick={() => setTabActive(tab.key)}
                                className={getProductTabClassName(tabActive === tab.key)}
                            >
                                {t(tab.labelKey)}
                            </li>
                        ))}
                    </ul>
                    <div id='content-body'>
                        {tabActive === 'TabOne' && (
                            <BaiscInfo
                                productName={productName}
                                setProductName={setProductName}
                                productDesc={productDesc}
                                setProductDesc={setProductDesc}
                                isShowOnWebsite={isShowOnWebsite}
                                setIsShowOnWebsite={setIsShowOnWebsite}
                                isActive={isActive}
                                setIsActive={setIsActive}
                                errors={errors}
                                productTypeSelected={productTypeSelected}
                                setProductTypeSelected={setProductTypeSelected}
                            />
                        )}
                        {tabActive === 'TabTwo' && (
                            <StockAndPrice
                                productCode={productCode}
                                setProductCode={setProductCode}
                                productPrice={productPrice}
                                setProductPrice={setProductPrice}
                                productBarcode={productBarcode}
                                setProductBarcode={setProductBarcode}
                                productFactoryCode={productFactoryCode}
                                setProductFactoryCode={setProductFactoryCode}
                                isStock={isStock}
                                setIsStock={setIsStock}
                                codeInStock={codeInStock}
                                setCodeInStock={setCodeInStock}
                                qty={qty}
                                setQty={setQty}
                                cost={cost}
                                setCost={setCost}
                                weightProduct={weightProduct}
                                setWeightProduct={setWeightProduct}
                                sizeProduct={sizeProduct}
                                setSizeProduct={setSizeProduct}
                                errors={errors}
                                uomSaleSelected={uomSaleSelected}
                                setUomSaleSelected={setUomSaleSelected}
                                uomPurchaseSelected={uomPurchaseSelected}
                                setUomPurchesSelected={setUomPurchesSelected}
                                uomTemplateSelected={uomTemplateSelected}
                                setTemplateUomSelected={setTemplateUomSelected}
                            />
                        )}
                        {tabActive === 'TabThree' && (
                            <ProductLinks
                                productCategorySelected={productCategorySelected}
                                setProductCategorySelected={setProductCategorySelected}
                                productBrandSelected={productBrandSelected}
                                setProductBrandSelected={setProductBrandSelected}
                                productTags={productTags}
                                setProductTags={setProductTags}
                                genProductCode={genProductCode}
                                setGenProductCode={setGenProductCode}
                                setProductCode={setProductCode}
                                productCode={productCode}
                            />
                        )}
                        {tabActive === 'TabFour' && (
                            <SEO
                                productMetaKeywords={productMetaKeywords}
                                setProductMetaKeywords={setProductMetaKeywords}
                                productMetaDesc={productMetaDesc}
                                setProductMetaDesc={setProductMetaDesc}
                            />
                        )}
                        {tabActive === 'TabFive' && (
                            <ProductImages
                                productHomePic={productHomePic}
                                loadingUploadHomePic={loadingUploadHomePic}
                                handleHomePicUpload={handleHomePicUpload}
                                productImages={productImages}
                                setProductImages={setProductImages}
                                productImagesItem={productImagesItem}
                                loadingUploadProductImages={loadingUploadProductImages}
                                handleImagesItemUpload={handleImagesItemUpload}
                                resultdelete={resultdelete}
                                loadingDeleting={loadingDeleting}
                                handleDelete={handleDelete}
                                setProductImagesDefault={setProductImagesDefault}
                            />
                        )}
                    </div>
                </div>
            </form>
        </div>
    )
}

export default CreateProduct
